import { createContext, useState } from 'react';

const GlobalContext = createContext(null);
export const SyncContext = createContext(null);

// initializing global state
const globalStateInit = {
    displayFeedback: 0,
    modalPopup: {
        show: false,
        title: '',
        message: '',
    },
        currentLessonObject: null,
    currentPageID: null,
    currentAnimationStep: null,
    playerUpdateTrigger: 1,
    showEditor: false,
    showExitConfirmDialog: false,
    showPreviewNoticeDialog: false,
    templateLessons: [],
    displayThreadsBoard: false,
    threadsBoardContext: null,
    threadsBoardSort: 'r',

    ENABLE_DISCUSSION_BOARDS: true, // disabled until mongodb was updated to replica-set mode
};

// Establishes GlobalContext via a custom use-hook.
//  returns as the context value and object containing the selection state and several useful updater functions
export function useGlobalContext(appVersion, isProEnabledVersion) {
    globalStateInit.appVersion = appVersion;
    globalStateInit.isProEnabledVersion = isProEnabledVersion;
    const [globalState, setGlobalState] = useState(globalStateInit);

    const updateGlobalState = (update) => {
        setGlobalState((prev) => ({ ...prev, ...update }));
    };

    // GlobalContext value
    return {
        ...globalState,
        update: updateGlobalState,
        clear: () => setGlobalState(globalStateInit),
    };
}

export default GlobalContext;